import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { CareType } from '../higherEd';
import { CurrentUser } from '../../resources';
import { SubSystem } from '@uplift/types';


export type PatientDetails = {
  userId: string;
  autopayEnabled: boolean;
  nonpaymentDeactivationEnabled: boolean;
  onboardingCaretypeSelection: CareType;
  onboardingRecommendedCaretype: CareType;
  isBetterhelpUser: boolean;
  isBetterhelpPaidTraffic: boolean;
};

export type GetPatientDetailsResponse = {
  data: PatientDetails;
};

export const getPatientDetails = async (patientId: string) => restClient.request<GetPatientDetailsResponse>(`/api/v1/patient/${patientId}/details`);

export type UpdatePatientDetailsInput = Partial<{
  onboardingCaretypeSelection: CareType | null;
  onboardingRecommendedCaretype: CareType | null;
}>;

export const updatePatientDetails = (patientId: string, details: UpdatePatientDetailsInput) => restClient.request(`/api/v1/patient/${patientId}/details`, {
  method: 'PATCH',
  data: snakecaseKeys(details),
});


export const checkBetterHelpUser = (me: CurrentUser, patientDetails?: PatientDetails) => {
  return patientDetails?.isBetterhelpUser || me.subsystem === SubSystem.betterhelp;
};
